'use client'

import * as React from 'react'

import { NavItem } from '@/types/nav'
import { Locale, defaultLocale } from '@/i18n/routing'
import { Link, usePathname } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { cn } from '@/lib/utils'
interface MainNavProps {
  items?: NavItem[]
  locale: Locale
}

export function MainNav({ items, locale }: MainNavProps) {
  // const siteConfig = getSiteConfig(locale)
  const t = useTranslations('MainNav')
  const linkLocale = locale === defaultLocale ? undefined : locale
  const pathname = usePathname()

  const isActive = React.useCallback(
    (href: string) => {
      if (!pathname) return false
      if (!href.startsWith('/')) return false
      if (href === '/') return pathname === '/'
      return pathname === href || pathname.startsWith(`${href}/`)
    },
    [pathname],
  )

  return (
    <div className="flex gap-6 md:gap-10">
      <Link
        href="/"
        locale={linkLocale}
        className="flex items-center space-x-3"
      >
        <Image src="/logo.png" alt="logo" width={48} height={48} priority />
        <span className="font-display text-xl text-white transition-colors">
          {t('title')}
        </span>
      </Link>
      {items?.length ? (
        <nav className="flex gap-6">
          {items?.map((item) => {
            if (!item.href) return null
            const active = isActive(item.href)

            return (
              <Link
                key={item.href}
                href={item.href}
                locale={linkLocale}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex items-center text-xs font-semibold uppercase tracking-[0.25em] transition-colors',
                  active ? 'text-white' : 'text-white/60 hover:text-amber-200',
                  item.disabled && 'cursor-not-allowed opacity-80',
                )}
              >
                {item.title}
              </Link>
            )
          })}
        </nav>
      ) : null}
    </div>
  )
}
